import { useContext } from 'react';

import { ChangelogContext } from '../context/ChangelogContext';

export function useChangelog() {
  const context = useContext(ChangelogContext);
  if (!context) {
    throw new Error(`useChangelog must be used within a ChangelogProvider`);
  }
  return context;
}
